export default (theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.border}`,
    backgroundColor: '#E1E1E1',
    display: 'flex',
    alignItems: 'center',
    height: '64px',
    zIndex: theme.zIndex.appBar,
  },
  toolbar: {
    minHeight: 'auto !important',
    width: '100%',
    paddingLeft: `${theme.spacing(5)} !important`,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      paddingLeft: `${theme.spacing(5)} !important`,
    },
  },
  title: {
    marginLeft: theme.spacing(1),
    //marginLeft: '170px'
  },
  chargeName: {
    fontWeight: 600,
    color: '#A53693',
    transition: 'all .3s ease-in-out',
    opacity: 0,
    transform: 'translateY(-10px)',
    fontSize: '20px',
    textTransform: 'uppercase',
  },
  dateBox: {
    transition: 'all .3s ease-in-out',
    transform: 'translate(50%, -10px)',
    opacity: 0,
  },
  date: {
    fontWeight: 600,
    color: 'white',
    opacity: 1,
    fontSize: '16px',
    textTransform: 'uppercase',
    backgroundColor: '#00AFEF',
    padding: '.5rem 1.5rem',
    borderRadius: '4px',
    [theme.breakpoints.down('sm')]: {
      marginRight: '0',
      marginLeft: '0',
    },
  },
  chargeNameVisible: {
    opacity: 1,
    transform: 'translateY(0)',
  },
  dateVisible: {
    opacity: 1,
    transform: 'translate(50%, 0)',
    [theme.breakpoints.down('md')]: {
      marginRight: '0',
      marginLeft: '0',
      transform: 'translate(-10%, 0)',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: '0',
      marginLeft: '0',
      transform: 'translate(0, 0)',
    },
  },
  menuButton: {
    marginLeft: `${theme.spacing(6)} !important`,
  },
  menuButtonOpen: {
    marginLeft: theme.spacing(3),
  },
  menuButtonMobile: {
    marginLeft: '0px',
  },
  notificationsButton: {
    marginLeft: 'auto !important',
    marginRight: '15px !important',
    display: 'block',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      marginRight: '0 !important',
      marginLeft: '0 !important',
      display: 'none',
    },
  },
  signOutButton: {
    right: theme.spacing(1),
  },
  backButton: {
    backgroundColor: `${theme.palette.common.secondary} !important`,
    color: '#fff',
  },
  translate: {
    fontWeight: '600 !important',
    display: 'flex',
    lineHeight: '0 !important',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
      padding: 0,
    },
  },
  hamburguerIcon: {
    marginLeft: '7px !important',
    marginRight: '7px !important',
    fontWeight: '600 !important',
    color: '#000 !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'space-between !important',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0',
      marginRight: '0',
      minWidth: '16px',
    },
  },
});
